/**
 * @see src/CamBundle/Message/Websocket/Record/RecordConversionFailed.php
 */

import * as t from 'io-ts';
import { UUID } from 'io-ts-types/UUID';
import { Type } from './Type';

export const RecordConversionFailedC = t.type({
    type: t.literal(Type.CONVERSION_FAILED),
    id: UUID,
});

export type RecordConversionFailed = t.TypeOf<typeof RecordConversionFailedC>;
